import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {ActivitySessionsV2QueryType} from "./__graphql-types__/index.ts";

const SKILL_LEVELS_FRAGMENT = gql`
    fragment ActivitySessionSkillLevels on SkillLevelChange {
        id
        before
        after
    }
`;

const ACTIVITY_SESSION_FRAGMENT = gql`
    fragment ActivitySession on ActivitySession {
        id
        title
        subtitle
        activityKind {
            id
        }
        durationMinutes
        eventTimestamp
        skillType
    }
`;

const ACTIVITY_SESSIONS_V2_QUERY: GqlOperation<
    ActivitySessionsV2QueryType["response"],
    ActivitySessionsV2QueryType["variables"]
> = gqlOp(gql`
    query ActivitySessionsV2Query(
        $studentKaid: String!
        $endDate: Date
        $startDate: Date
        $courseType: String
        $activityKind: String
        $after: ID
        $pageSize: Int
    ) {
        user(kaid: $studentKaid) {
            id
            activityLogV2(
                endDate: $endDate
                startDate: $startDate
                courseType: $courseType
                activityKind: $activityKind
            ) {
                time {
                    exerciseMinutes
                    totalMinutes
                }
                activitySessions(pageSize: $pageSize, after: $after) {
                    sessions {
                        ...ActivitySession
                        ... on BasicActivitySession {
                            aiGuideThread {
                                title
                                id
                            }
                            essaySession {
                                essayTitle
                                id
                            }
                        }
                        ... on MasteryActivitySession {
                            correctCount
                            problemCount
                            skillLevels {
                                ...ActivitySessionSkillLevels
                                exercise {
                                    id
                                    translatedTitle
                                }
                            }
                            task {
                                id
                                isRestarted
                            }
                        }
                    }
                    pageInfo {
                        nextCursor
                    }
                }
            }
        }
    }

    ${ACTIVITY_SESSION_FRAGMENT}
    ${SKILL_LEVELS_FRAGMENT}
`);

export default ACTIVITY_SESSIONS_V2_QUERY;
